const topMain = () => {
  if (document.querySelector("body#pageTop") !== null) {



    let sW = window.innerWidth;

    let sec = document.querySelector('#jsSecMain');
    let wrap = sec.querySelector('.js-main-wrap');

    // let imgBox = wrap.querySelector('.js-img-box');

    let ttlBox = wrap.querySelector('.js-ttl-box');
    let copyBox = wrap.querySelector('.js-copy-box');

    let videoBox = wrap.querySelector('.js-video-box');
    let video
    if (sW > 768) {
      video = videoBox.querySelector('.js-video-pc');
    } else {
      video = videoBox.querySelector('.js-video-sp');
    }
    video.play()

    // let header = document.querySelector('header.crevia-common.header');



    video.addEventListener('ended', (event) => {
      videoBox.classList.add('is-act')
      ttlBox.classList.add('is-act')

      setTimeout(() => {
        copyBox.classList.add('is-act')
        // setTimeout(() => {
        //   header.classList.add('is-act')
        // }, 1600);
      }, 1600);

    });


    // setTimeout(() => {


    //   setTimeout(() => {
    //     ttlBox.classList.add('is-act')


    //     setTimeout(() => {
    //       copyBox.classList.add('is-act')
    //       setTimeout(() => {
    //         header.classList.add('is-act')
    //       }, 1200);
    //     }, 1200);

    //   }, 2400);

    // }, 300);



  }
}
export default topMain;